import React from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { Container, Header } from 'components/common'
import PublicPageContainer from '../PublicPageContainer'
import { StepIndicator } from './StepIndicator'
import { Step1 } from './cardholderSignupSteps/step1'
import { Step2 } from './cardholderSignupSteps/step2'
import { Step3 } from './cardholderSignupSteps/step3'
import { Step4 } from './cardholderSignupSteps/step4'
import { BenefitItem } from './BenefitItem'

import { useSignUpCardholderForm } from './useSignUpCardholderForm'

import security_assessments from 'assets/images/security_assessments.svg'
import impact_analysis from 'assets/images/impact_analysis.svg'
import infrastructure_assessments from 'assets/images/infrastructure_assessments.svg'

import './SignUpCardholder.scss'

/**
 * SignIpCarholder components containns the structure for the carholder benefit sign up flow
 * See useSignUpCardholderForm for any logic behind validations, error handeling and requests
 */
const SignUpCardholder = () => {
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const accessCodeParam = queryParams.get('access_code')

  const { t } = useTranslation('pub', {
    keyPrefix: 'PublicRoutes.signUp',
  })

  const {
    state,
    localDispatch,
    submitting,
    submittingStep3,
    agree,
    setAgree,
    currentStep,
    customerRegions,
    handleWidgetStep1Success,
    handleNext,
    handleStep3Submit,
    canProceedStep2,
    canProceedStep3,
  } = useSignUpCardholderForm(accessCodeParam)

  return (
    <PublicPageContainer>
      <div className="sign-up-container">
        <div className="sign-up-grid">
          <div className="mcr-benefits">
            <Header as="h2">{t('benefits')}</Header>
            <div className="benefits-subtitle">{t('benefitsDesc')}</div>

            <BenefitItem
              imageSrc={security_assessments}
              imageAlt="Security assessments icon"
              title={t('securityAssessments')}
              description={t('securityAssessmentsDesc')}
            />

            <BenefitItem
              imageSrc={infrastructure_assessments}
              imageAlt="Infrastructure assessments icon"
              title={t('infrastructureAssessments')}
              description={t('infrastructureAssessmentsDesc')}
            />

            <BenefitItem
              imageSrc={impact_analysis}
              imageAlt="Impact analysis icon"
              title={t('impactAnalysis')}
              description={t('impactAnalysisDesc')}
            />
          </div>

          <div>
            <Container id="gather-company-info-container">
              {currentStep < 4 && (
                <StepIndicator currentStep={currentStep} totalSteps={3} />
              )}

              <div className="user-onboard-form-container-cardholder">
                <form className="user-onboard-form">
                  {currentStep === 1 && (
                    <Step1
                      onNext={(cardNumberId) => {
                        handleWidgetStep1Success(cardNumberId)
                      }}
                    />
                  )}

                  {currentStep === 2 && (
                    <Step2
                      state={state}
                      localDispatch={localDispatch}
                      customerRegions={customerRegions}
                      agree={agree}
                      setAgree={setAgree}
                      onNext={handleNext}
                      canProceed={canProceedStep2}
                      submitting={submitting}
                    />
                  )}

                  {currentStep === 3 && (
                    <Step3
                      state={state}
                      localDispatch={localDispatch}
                      onSubmit={handleStep3Submit}
                      submitting={submittingStep3}
                      canProceed={canProceedStep3}
                    />
                  )}

                  {currentStep === 4 && <Step4 />}
                </form>
              </div>
            </Container>
            <div className="account-already">
              {t('accountAlready')}&nbsp;
              <a href={process.env.REACT_APP_AUTH_URL}>{t('logIn')}</a>
            </div>
          </div>
        </div>
      </div>
    </PublicPageContainer>
  )
}

export default SignUpCardholder
